import React from 'react';
import PropTypes from 'prop-types';
import Edit from './rowActions/Edit';
import Duplicate from './rowActions/Duplicate';
import Delete from './rowActions/Delete';
import { Box, Stack } from '@mui/material';

const RowActions = ({ rowData, setDetailCallbackComponent }) => <Stack direction="row" >
  <Edit rowData = {rowData} setDetailCallbackComponent = {setDetailCallbackComponent}/>
  <Duplicate rowData = {rowData} />
  <Delete rowData = {rowData} />
</Stack>;


RowActions.propTypes = {
  row: PropTypes.object.isRequired,
  setDetailCallbackComponent: PropTypes.func
};


export default RowActions;
